
import React, { useEffect, useState } from "react";
import styles from './NewDeviceNotification.module.css';
import MessageComp from "../MessageComp/MessageComp";
import { delDevicesNotification } from "../../store/notificationSlice";

import { useDispatch } from "react-redux";
import toast, { Toaster } from 'react-hot-toast';
import { AiOutlineCheck } from "react-icons/ai";

const NewDeviceNotification = ({ profileData })=>{

    const [network, setNetwork] = useState('');
    const [country, setCountry] = useState('');
    const [ip, setIp] = useState('');
    

    const getCurrentUserIp = async ()=>{
        sessionStorage.setItem('user_logged_devices', devices);
        const externalIPEndpoint = 'https://api.ipinfo.io/lite/me?token=e1604f394faefc';

        try {
            const res = await fetch(externalIPEndpoint);

        if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
            }

            const data = await res.json();
            setIp(data.ip)
            setCountry(data.country)
            // setCountryCode(data.country_code)
            // setContinent(data.continent)
            setNetwork(data.as_name)

        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }

    useEffect(()=>{
        getCurrentUserIp();
    });

    const dispatch = useDispatch();

    const messageDeletedSucesfully = ()=> toast.success(`${user_acct} logged devices cannot be truncated`, {
        icon: <AiOutlineCheck />,
        iconTheme:  {
            primary:'',
            secondary: ''
        }
    });

        const user_acct = profileData?.firstname;
        const uDate = new Date().toLocaleDateString();
        const uTime = new Date().toLocaleTimeString();

           const devices = [
            {
                id: 1,
                heading: `Login attempted from ${country}, ${network}`,
                txt: `The system has detected that your account is logged in from ${ip}. Account: ${user_acct}...`,
                date: `${uDate}`,
                time: `${uTime}`
            },
            {
                id: 2,
                heading: `Login attempted from ${country}, ${network}`,
                txt: `The system has detected that your account is logged in from ${ip}. Account: ${user_acct}...`,
                date: `${uDate}`,
                time: `${uTime}`
            },
            {
                id: 3,
                heading: `Login attempted from ${country}, ${network}`,
                txt: `The system has detected that your account is logged in from ${ip}. Account: ${user_acct}...`,
                date: `${uDate}`,
                time: `${uTime}`
            },
        ];

    return(<>    

            <Toaster 
                gutter={10} 
                position="top-right"
                reverseOrder={false}
                className={styles.toaster_comp_}
                toastOptions={{
                    success: {
                        style: {
                            background: 'rgb(148, 246, 246)',
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: '14px',
                            borderRadius: '3px',
                            padding: '1rem',
                            fontWeight:'bold'
                        }
                    },
                    error: {
                        style: {
                            background: '#ba1100',
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: '13.4px',
                            borderRadius: '3px',
                            padding: '1rem'
                        }
                    },
                }}
                containerStyle= {{
                    right: 20
            }}
            />

        <div className={styles.asdfghjkl_asdfghjkl}>
            
            <div className={styles.AllNotifications_wrapper__}>

                {
                    devices.map( (val, ind)=> (
                        <MessageComp key={ind} 
                        heading={val.heading}
                        txt={val.txt}
                        date={val.date}
                        time={val.time}
                        deleteProps={()=>{
                            dispatch( delDevicesNotification({ id: val.id }) )
                            messageDeletedSucesfully()
                        }}
                        />
                    ) )
                }
                
            </div>

        </div>
    </>)
}

export default NewDeviceNotification; 